import CacheExtension from "../../Filter/CacheExtension";

export default class EmailAutoForm {
    #state
    constructor(parameter) {
        this.#state = {
            mandatory : false,
            modale : parameter.modale,
            parameter : parameter
        }
        if (this.#state.keyform) {
            this.#state.mandatory = true
        }
    };

    check() {
        var checkValue = true
        var returnTable = []
        var errorCode = ""
        var arrayInput = {}
        var className = "." +  this.#state.parameter.parameterkeyForm + "-" + this.#state.parameter.parameterName + "-"+this.#state.parameter.parameterData
        var input = document.querySelector(className)
        if (input.value === "" &&  this.#state.mandatory === true) {
            checkValue = false
        }
        if (input.value.trim() === "") {
            checkValue = false
            errorCode = -1070
        }

        returnTable.push(checkValue,input.name,input.value,errorCode)
        return returnTable
    }

    render() {
        return(
            <div key={Math.random()} className={`banner ${ this.#state.modale == true ? "form-group" : ""}`}>
                <label>{CacheExtension.getDataFromCache('label-' + this.#state.parameter.parameterkeyForm + "-" + this.#state.parameter.parameterName + "-"+this.#state.parameter.parameterData)}</label>
                <input required={this.#state.mandatory} placeholder={CacheExtension.getDataFromCache('placeholder-' + this.#state.parameter.parameterkeyForm + "-" + this.#state.parameter.parameterName + "-"+this.#state.parameter.parameterData)} name={this.#state.parameter.parameterData} className={this.#state.parameter.parameterkeyForm + "-" + this.#state.parameter.parameterName + "-"+this.#state.parameter.parameterData + " form-control"} id={this.#state.parameter.parameterClass + '-' + this.#state.parameter.parameterData} type="text"/>
            </div>
        )
    }
};

